interface ErrorWithResponse {
    response?: { status?: number }
}

export const isBranchNotFoundError = (error: unknown) => {
    if (typeof error !== 'object' || error == null) return false

    return (error as ErrorWithResponse).response?.status === 404
}
